import { Link } from 'react-router-dom';

const logoUrl = 'https://storage.readdy-site.link/project_files/3596fc25-c69f-44a2-abe5-af3ab65b5565/e8b3a63e-77b3-40d1-bcf9-c504e7feaaa0_logo-Photoroom.png?v=da203c0422d47544374c94eda10a1af6';

export default function Footer() {
  return (
    <footer className="bg-primary-900">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* 服務項目 */}
          <div>
            <h3 className="text-sm font-bold text-white mb-5 tracking-wide">
              服務項目
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  產官學資源整合
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  財稅管理顧問
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  AI 數位轉型
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  ESG 永續規劃
                </Link>
              </li>
            </ul>
          </div>

          {/* 關於我們 */}
          <div>
            <h3 className="text-sm font-bold text-white mb-5 tracking-wide">
              關於我們
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  公司簡介
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  經營理念
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  專業團隊
                </Link>
              </li>
            </ul>
          </div>

          {/* 快速連結 */}
          <div>
            <h3 className="text-sm font-bold text-white mb-5 tracking-wide">
              快速連結
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  首頁
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  服務項目
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  最新資訊
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/70 hover:text-accent-500 transition-colors duration-200">
                  聯絡方式
                </Link>
              </li>
            </ul>
          </div>

          {/* 聯絡資訊 */}
          <div>
            <h3 className="text-sm font-bold text-white mb-5 tracking-wide">
              聯絡資訊
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-accent-500 text-sm" />
                </div>
                <span className="text-sm text-white/70 leading-relaxed">
                  台中市西屯區市政北二路 236 號 20 樓 15 室（七期館）
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-accent-500 text-sm" />
                </div>
                <span className="text-sm text-white/70">0909-518-828</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-accent-500 text-sm" />
                </div>
                <span className="text-sm text-white/70">abc10616@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-10 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex items-center gap-3">
              <img
                src={logoUrl}
                alt="得運智科"
                className="h-20 w-auto object-contain"
              />
              <div>
                <h2 className="text-xl font-bold text-white tracking-tight">
                  得運智科
                </h2>
                <p className="text-xs text-white/60 mt-0.5">
                  讓企業升級更有方向
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-line-fill text-white text-sm" />
              </div>
              <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-white text-sm" />
              </div>
              <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line text-white text-sm" />
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-white/40">
              &copy; 2024 得運智科股份有限公司. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}